'use-client';
import React from 'react';
import type {
  VerticalMenuProps,
  VerticalMenuImperativeActions,
} from '../../../VerticalMenu.types';
import VerticalMenuRoot from '../../VerticalMenuRoot';
import styles from './styles/skins.scss';

const VerticalMenuSeparatedButtonSkin: React.ForwardRefRenderFunction<
  VerticalMenuImperativeActions,
  VerticalMenuProps
> = (props, ref) => (
  <VerticalMenuRoot
    {...props}
    ref={ref}
    style={styles}
    separatedButton={true}
  />
);

export default React.forwardRef(VerticalMenuSeparatedButtonSkin);
